export default "__VITE_ASSET__f2de2924__"